/**
 * The two top-level chat-convergence destinations a Quick Find query can be routed to:
 * Rovo chat on Home, or full page search.
 *
 * Lives in `common` (not the `ui` chat-intent-router folder) so the analytics event
 * helper can reference the type without `common` importing from `ui`.
 */
// oxlint-disable-next-line eslint/no-redeclare
export const ChatIntentMode = { CHAT: 'chat', SEARCH: 'search' } as const;
export type ChatIntentMode = (typeof ChatIntentMode)[keyof typeof ChatIntentMode];
